import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { SkillDetailsStatus, SummaryRating } from '@core/positions-and-skills-types';
import { RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-job-skill-scale-rating',
  templateUrl: './job-skill-scale-rating.component.html',
  styleUrls: ['./job-skill-scale-rating.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RtTooltip, TranslatePipe],
})
export class JobSkillScaleRatingComponent {
  protected readonly SkillDetailsStatus = SkillDetailsStatus;

  public readonly rating = input.required<SummaryRating>();
  public readonly status = input.required<SkillDetailsStatus>();

  protected scale = computed(() =>
    Array.from({ length: this.rating().scale }).map((_, i) => i + 1),
  );
}
